import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { TerminalRegistrationRepository } from '@app/domain/ports/tpv/terminal-registration.repository';
import { CreateTerminalDto } from '@app/data/dtos/tpv/register-terminal.dto';
import { tpvUrl } from '@app/data/tpv/tpv-api.config';
import { TpvEnvelope } from '@app/data/tpv/tpv-envelope';

/**
 * Implementación HTTP del alta de terminales (`api/v1/tpv/terminals/register/`, §4).
 *
 * Auth: NO setea `x-api-key` ni `Skip-Auth-Interceptor`. El `authInterceptor`
 * agrega el Bearer y maneja 401/refresh; el `ApiKeyInterceptor` agrega el
 * `x-api-key`. La `Idempotency-Key` es OPCIONAL (la terminal ya tiene clave
 * natural): solo se añade si se provee. Devuelve 201.
 */
@Injectable()
export class TerminalRegistrationRemoteDataSource extends TerminalRegistrationRepository {
  private readonly http = inject(HttpClient);

  override registerTerminal(
    dto: CreateTerminalDto,
    idempotencyKey?: string,
  ): Observable<void> {
    return this.http
      .post<TpvEnvelope<unknown>>(tpvUrl('terminals/register/'), dto, {
        headers: this.buildHeaders(idempotencyKey),
      })
      .pipe(map(() => void 0));
  }

  private buildHeaders(idempotencyKey?: string): HttpHeaders {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    if (idempotencyKey) {
      headers = headers.set('Idempotency-Key', idempotencyKey);
    }
    return headers;
  }
}
